module.exports = __webpack_public_path__ + "static/media/InterviewModeModerator.fdef6ea9.svg";